import { useQuery } from '@tanstack/react-query';
import { brainiacsService } from '../components/core/services/brainiacs.service';

export const useInvoices = () => {
  return useQuery({
    queryKey: ['invoices', 'list'],
    queryFn: () => brainiacsService.getInvoices({ limit: 50 }),
    staleTime: 15 * 60 * 1000,  // 15 minutes - invoices rarely change
    gcTime: 30 * 60 * 1000,     // 30 minutes - keep in cache longer
    enabled: false,              // Only fetch when explicitly enabled
  });
};
